import type { CmsBlockDescriptor } from '../store/types'

export const FOOD_BOX_PAGE: CmsBlockDescriptor = {
  contentType: 'cms_page',
  pageUrl: '/food-box',
}
